import type { TFunction } from 'i18next'

export const successMessage = (t: TFunction) => t('general_success')
export const errorMessage = (t: TFunction) => t('fatal_error_title')
export const processingMessage = (t: TFunction) => t('general_processing')

export const actCreated = (t: TFunction) =>
	t('created', { defaultValue: 'Created' })
export const actUpdated = (t: TFunction) =>
	t('updated', { defaultValue: 'Updated' })
export const actSaved = (t: TFunction) => t('saved', { defaultValue: 'Saved' })
export const actDeleted = (t: TFunction) =>
	t('deleted', { defaultValue: 'Deleted' })
export const actRestored = (t: TFunction) =>
	t('restored', { defaultValue: 'Restored' })
export const actPublished = (t: TFunction) =>
	t('published', { defaultValue: 'Published' })

export const successActionMessage = (
	value: string,
	action: string,
	t: TFunction
) => t('{value}_successfuly_{action}', { value, action })
